import FilterIcon from "@/components/icons/filter-icon"
import { langStore } from "@/stores/lang-store"
import { useToggleStore } from "@/hooks/use-toggle-store"
import { SearchIcon } from "pk-icons"

const extra = {
  placeholder: { ko: "수용가 번호로 검색", en: "Search by Customer", es: "Buscar por cliente" },
  filter: { ko: "필터", en: "Filters", es: "Filtros" },
  search: {
    result: { ko: "검색 결과", en: "Results", es: "Resultados de búsqueda" },
    unit: { ko: "개", en: "items", es: "artículos" }
  }
}

const TableToolbar = ({ search, resultCountText }) => {
  const { lang } = langStore()

  const { show, open } = useToggleStore("filter")

  return (
    <div className="flex flex-col gap-1 md:gap-3 md:flex-row md:justify-between md:items-end pr-0 md:pr-4">
      <div className="flex w-full md:w-auto items-center gap-0">
        <label className="relative w-full md:w-auto">
          <SearchIcon className="absolute left-3 top-1/2 -translate-y-1/2" size={18} color="#777" />
          <input
            type="text"
            placeholder={extra.placeholder[lang]}
            className="w-full md:w-[320px] bg-[rgba(2,32,71,0.05)] pl-9 pr-3 py-2 rounded-l-md border-r border-r-gray-200 
              focus:outline-none focus:bg-[rgba(2,32,71,0.1)]"
            onChange={search}
          />
        </label>

        <button
          className={`shrink-0 flex items-center gap-2 px-2 py-2 rounded-r-md hover:bg-[rgba(2,32,71,0.1)] cursor-pointer
            ${show ? "bg-[rgba(2,32,71,0.1)]" : "bg-[rgba(2,32,71,0.05)]"}
          `}
          onClick={open}
        >
          <FilterIcon />
          {extra.filter[lang]}
        </button>
      </div>

      <div className="text-gray-700 pl-1 text-sm md:text-base">
        {extra.search.result[lang]} : {resultCountText} {extra.search.unit[lang]}
      </div>
    </div>
  )
}

export default TableToolbar
